export default "assets/images/accordsparfait-en-5f98bea4.png";